
const login = {
  data: {
    Username: null,
    Password: null,
    AuthType: null,
    ApplicationId: "",

  },
  activeUserData: {},
  isLoadingFullScreen: false,
  showPassInput: false,
  disableButton: true,
  isAccountActive: true,
  isAccountTemp: false,
  message: null,

};

export default login;

